import { Breakpoints, Layout } from '@volkswagen-onehub/components-core';
import * as React from 'react';
import { useIsLandscape } from '../../../../../../hooks/use-is-landscape';
import { BonoCardBackground } from '../../../shared/ui/bono-card-backgound';

export const PopupHuchaCardContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const isLandscape = useIsLandscape();
	const c2Columns = isLandscape ? 9 : 24;
	const c3Columns = isLandscape ? 15 : 24;

	return (
		<BonoCardBackground
			stretchContent
			verticalAlign="center"
			horizontalAlign="center"
			data-testid="hucha-card-container"
			wrap={{
				[Breakpoints.default]: 'always',
				[Breakpoints.b1600]: 'never',
			}}
		>
			<Layout
				data-testid="hucha-card-layout"
				appearance={{
					[Breakpoints.default]: [
						{ name: 'popup-hucha-card-c2', columns: 24 },
						{ name: 'popup-hucha-card-c3', columns: 24 },
					],
					[Breakpoints.b960]: [
						{ name: 'popup-hucha-card-c2', columns: c2Columns },
						{ name: 'popup-hucha-card-c3', columns: c3Columns },
					], // aqui entre 960 y 1280 si es vertical 24, 24 y si es horizontal 9, 15 (useIsLandscape)
					[Breakpoints.b1280]: [
						{ name: 'popup-hucha-card-c2', columns: 10 },
						{ name: 'popup-hucha-card-c3', columns: 14 },
					],
				}}
			>
				{children}
			</Layout>
		</BonoCardBackground>
	);
};

export const PopupHuchaCardContainer2: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<BonoCardBackground
			stretchContent
			verticalAlign="center"
			horizontalAlign="center"
			data-testid="hucha-card-container"
			wrap={{
				[Breakpoints.default]: 'always',
				[Breakpoints.b1600]: 'never',
			}}
		>
			<Layout
				data-testid="hucha-card-layout"
				appearance={{
					[Breakpoints.default]: [
						{ name: 'popup-hucha-card-c2', columns: 24 },
						{ name: 'popup-hucha-card-c3', columns: 24 },
					],
					[Breakpoints.b960]: [
						{ name: 'popup-hucha-card-c2', columns: 10 },
						{ name: 'popup-hucha-card-c3', columns: 14 },
					],
					[Breakpoints.b1280]: [
						{ name: 'popup-hucha-card-c2', columns: 11 },
						{ name: 'popup-hucha-card-c3', columns: 13 },
					],
				}}
			>
				{children}
			</Layout>
		</BonoCardBackground>
	);
};
